import { AbstractPageDataProvider, PageDefaults } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IProduct } from "@/models/product.entity";
import productService from "@/services/mrfiktiv/services/product.service";
import { MrfiktivProductControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const ProductPageDataProvider = new (class extends AbstractPageDataProvider<
  IProduct,
  MrfiktivProductControllerGetParamsGen
> {
  itemsPerPage = PageDefaults.DEFAULT_PAGE_SIZES[5];

  async getPage(query: MrfiktivProductControllerGetParamsGen): Promise<IPageViewModel<IProduct>> {
    const res = await productService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IProduct[];

    return { meta, data };
  }
})();
